module.exports = __webpack_public_path__ + "img/5.e067529d.png";